import { render, staticRenderFns } from "./GestioneAppuntamentoModalComponent.vue?vue&type=template&id=76df6bc4&scoped=true"
import script from "./GestioneAppuntamentoModalComponent.vue?vue&type=script&lang=js"
export * from "./GestioneAppuntamentoModalComponent.vue?vue&type=script&lang=js"
import style0 from "./GestioneAppuntamentoModalComponent.vue?vue&type=style&index=0&id=76df6bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76df6bc4",
  null
  
)

export default component.exports